var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 22,
    cy: 21.5455,
    r: 21.123,
    fill: "#D9FE72",
    fillOpacity: 0.07,
    stroke: "#D9FE72",
    strokeWidth: 0.84492
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.9667 12.6738H29.8262L23.5799 19.8311L30.929 29.5722H25.1754L20.6658 23.6655L15.5116 29.5722H12.6495L19.33 21.9141L12.2832 12.6752H18.1833L22.2534 18.0731L26.9667 12.6738ZM25.9612 27.8568H27.5461L17.3176 14.3H15.6181L25.9612 27.8568Z",
    fill: "#D9FE72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.c605f7159b0975cfc45ae1c1183aa8f9.svg";
export { ForwardRef as ReactComponent };